import { graphql } from 'gatsby';
import PropType from 'prop-types';
import React from 'react';

import BlockHeroTextAltSlice from '../components/BlockHeroTextAltSlice';
import { Meta } from '../components/Meta';
import BlockContactSlice from '../components/slices/BlockContactSlice';
import BlockBlogs from '../intl-blogs/emea-blog/components/BlockBlogs';
import { Schemas } from '../seo/Schemas';

export const Head = ({ data, pageContext, location: { pathname } }) => {
  const { siteURL } = pageContext;
  const page = data.allPrismicPage?.edges[0]?.node.data;
  return (
    <>
      <Meta
        pageContext={pageContext}
        pageTitle={page?.seo_title}
        title={page?.seo_title}
        description={page?.seo_description}
        url={`${siteURL}/${pathname}`}
        canonicalUrl={`${siteURL}/${pathname.replace(/blog.*$/, '/blog/')}`}
      />
      <Schemas data={data} pageContext={pageContext} />
    </>
  );
};

const BlogIndex = ({ data, pageContext }) => {
  const posts = data.allWpPost.nodes;
  const doc = data.allPrismicPage.edges[0]?.node?.data;

  const heroTextAltSlice = doc?.body?.find(
    (slice) => slice.slice_type === 'block_hero_text_alt'
  );
  const contactSlice = doc?.body?.find(
    (slice) => slice.slice_type === 'block_contact'
  );

  return (
    <>
      {heroTextAltSlice && <BlockHeroTextAltSlice slice={heroTextAltSlice} />}
      {posts.length > 0 ? (
        <BlockBlogs
          posts={posts}
          previousPagePath={pageContext.previousPagePath}
          nextPagePath={pageContext.nextPagePath}
        />
      ) : (
        <p>
          No blog posts found. Add posts to your WordPress site and they'll
          appear here!
        </p>
      )}
      {contactSlice && <BlockContactSlice slice={contactSlice} />}
    </>
  );
};

BlogIndex.propTypes = {
  data: PropType.object,
  pageContext: PropType.object,
};

export default BlogIndex;

export const pageQuery = graphql`
  query WordPressPostArchive(
    $offset: Int!
    $postsPerPage: Int!
    $siteTag: String!
    $siteLang: String!
  ) {
    allPrismicPage(
      filter: {
        tags: { eq: $siteTag }
        data: { slug: { regex: "/^/?blog/?$/" }, locale: { eq: $siteLang } }
      }
    ) {
      edges {
        node {
          data {
            slug
            seo_title
            seo_description
            body {
              ... on PrismicPageDataBodyBlockHeroTextAlt {
                slice_type
                primary {
                  eyebrow {
                    richText
                  }
                  button {
                    richText
                  }
                  description {
                    richText
                  }
                  heading {
                    richText
                  }
                }
              }

              ... on PrismicPageDataBodyBlockContact {
                slice_type
                primary {
                  background_image {
                    url
                    alt
                  }
                  button {
                    html
                    richText
                    text
                  }
                  color
                  content {
                    html
                    richText
                    text
                  }
                  title_end {
                    html
                    richText
                    text
                  }
                  title_middle {
                    html
                    richText
                    text
                  }
                  title_start {
                    html
                    richText
                    text
                  }
                }
              }
            }
          }
        }
      }
    }

    allWpPost(sort: { date: DESC }, limit: $postsPerPage, skip: $offset) {
      nodes {
        excerpt
        uri
        date(formatString: "MMMM DD, YYYY")
        title
        excerpt
        featuredImage {
          node {
            altText
            localFile {
              childImageSharp {
                fluid(maxWidth: 1000, quality: 100) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  }
`;
